import React from 'react';
import { FormattedMessage } from 'react-intl';

export const optionTypes = {
  liveRate: {
    id: '1',
    value: 'live-rate',
    displayName: <FormattedMessage defaultMessage='Live Rate' description='delivery options option type live rate' id='UrN42Q' />,
  },
  free: {
    id: '2',
    value: 'free',
    displayName: <FormattedMessage defaultMessage='Free' description='delivery options option type free' id='VTt6Vu' />,
  },
  flatRate: {
    id: '3',
    value: 'flat-rate',
    displayName: <FormattedMessage defaultMessage='Flat Rate' description='delivery options option type flat rate' id='JkewV/' />,
  },
  fallbackRate: {
    id: '4',
    value: 'fallback-rate',
    displayName: <FormattedMessage defaultMessage='Fallback Rate' description='delivery options option type fallback rate' id='CQa5Lr' />,
  },
  'local-delivery': {
    id: '5',
    value: 'local-delivery',
    displayName: (
      <FormattedMessage defaultMessage='Local Delivery Rate' description='delivery options option type local delivery' id='XQ4oPR' />
    ),
  },
};
